import { SCALE_SLOTS } from './DanmarksKortMap.constants.js'

export const parseNumericValue = (raw) => {
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null
  if (typeof raw !== 'string') return null

  let text = raw.trim()
  if (text === '') return null

  const isPercent = text.endsWith('%')
  if (isPercent) text = text.slice(0, -1).trim()

  if (text.includes(',')) text = text.replace(/\./g, '').replace(',', '.')
  if (!/^[+-]?(\d+\.?\d*|\.\d+)$/.test(text)) return null

  const number = Number(text)
  if (!Number.isFinite(number)) return null
  return isPercent ? number / 100 : number
}

const normalizeKey = (raw) => String(raw).trim().toLowerCase()

export const buildLegendIndex = (legend) => {
  const entries = (legend ?? [])
    .map((entry, i) => ({
      value:  entry?.value == null ? '' : String(entry.value).trim(),
      label:  entry?.label ?? '',
      slot:   Number.isInteger(entry?.slot) ? entry.slot : i + 1,
      number: parseNumericValue(entry?.value)
    }))
    .filter(e => (e.value !== '' || e.label !== '') && e.slot >= 1 && e.slot <= SCALE_SLOTS)

  const matchable = entries.filter(e => e.value !== '')
  if (!matchable.length) return { mode: 'implicit', entries }

  if (matchable.every(e => e.number != null)) {
    return { mode: 'threshold', entries, ascending: [...matchable].sort((a, b) => a.number - b.number) }
  }

  return { mode: 'category', entries, byKey: new Map(matchable.map(e => [normalizeKey(e.value), e.slot])) }
}

export const resolveLegendSlot = (index, value) => {
  if (value == null || String(value).trim() === '') return null

  if (index.mode === 'category') return index.byKey.get(normalizeKey(value)) ?? null

  if (index.mode === 'threshold') {
    const number = parseNumericValue(value)
    if (number == null) return null
    const bucket = index.ascending.find(e => number <= e.number) ?? index.ascending[index.ascending.length - 1]
    return bucket.slot
  }

  return null
}
